<template>
  <v-container fluid class="invoice-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs color="primary">
          <v-tab v-if="initvalue.invoicestatus=='New'" :href="`#tab-invoice`" class="mr-5">
            <v-icon class="mr-3">mdi-text-box-outline</v-icon>
            Invoice
          </v-tab>
          <v-tab v-if="initvalue.invoicestatus=='New'" class="mr-5" :href="`#tab-items`" >
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Items
          </v-tab>
          <v-tab :href="`#tab-files`" class="mr-5">
            <v-icon class="mr-3">mdi-file-pdf-box</v-icon>
            Files
          </v-tab>
          <v-tab-item :value="'tab-invoice'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Invoice</p>
                      <v-select
                        readonly
                        class="mb-4"
                        :items="invoicetype"
                        v-on:change="onChangeValue($event, 'invoicetype')"
                        v-bind:error="errorindex == 0"
                        v-bind:value="initvalue.invoicetype"
                        outlined
                        dense
                        placeholder="Type"
                        persistent-hint
                        single-line
                        hint="Please choose the invoice type"
                      >
                      </v-select>
                      <v-menu
                        ref="menu_invoicedate"
                        v-model="menu_invoicedate"
                        :close-on-content-click="false"
                        :return-value.sync="invoicedate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            outlined
                            dense
                            v-model="invoicedate"
                            v-bind:value="initvalue.invoicedate"
                            label="Invoice Date"
                            v-bind="attrs"
                            v-on:change="
                              onChangeValue($event, 'invoicedate')
                            "
                            v-bind:error="errorindex == 1"
                            v-on="on"
                            single-line
                            hint="Please choose the invoice date"
                          >
                            ></v-text-field
                          >
                        </template>
                        <v-date-picker
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="menu_invoicedate = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="onChangeValue(invoicedate,'invoicedate'); $refs.menu_invoicedate.save(invoicedate);"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                      <v-select
                        class="mb-4"
                        :items="locations.map(x => {return {text: x.locationname, value: x._id};})"
                        v-bind:value="initvalue.locationid"
                        v-on:change="onChangeValue($event, 'locationid')"
                        v-bind:error="errorindex == 6"
                        outlined
                        dense
                        placeholder="Location"
                        persistent-hint
                        single-line hint="Please choose the location">
                      </v-select>
                      <v-select
                        v-if="initvalue.invoicetype=='Invoice'"
                        class="mb-4"
                        :items="pricelists.map(x => {return {text: x.pricelistname, value: x._id};})"
                        v-bind:value="initvalue.pricelistid"
                        v-on:change="onChangeValue($event, 'pricelistid')"
                        outlined
                        dense
                        placeholder="Price List"
                        persistent-hint
                        single-line hint="Please choose the pricelist">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="['New', 'Partial', 'Completed']"
                        v-bind:value="initvalue.invoicestatus"
                        v-on:change="onChangeValue($event, 'invoicestatus')"
                        outlined
                        dense
                        placeholder="Status"
                        persistent-hint
                        single-line
                        hint="Please choose the status"
                      >
                      </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-text-field
                        class="mb-4"
                        append-icon="mdi-magnify"
                        placeholder="Customer Name"
                        single-line hint="Select the Customer"
                        outlined
                        dense
                        readonly
                        @click:append="searchCustomerDialog"
                        persistent-hint
                        v-bind:value="initvalue.invoicename"
                        v-bind:error="errorindex == 3"
                      >
                      </v-text-field>  
                      <v-textarea
                        outlined
                        v-bind:value="initvalue.invoiceaddress"
                        v-on:change="
                          onChangeValue($event, 'invoiceaddress')
                        "
                        rows="2"
                        label="Address"
                        hint="please enter the customer address"
                      ></v-textarea>
                      <v-text-field
                        class="mb-4"
                        v-bind:value="initvalue.invoicephone"
                        v-on:change="
                          onChangeValue($event, 'invoicephone')
                        "
                        outlined
                        v-bind:error="errorindex == 11"
                        dense
                        placeholder="Phone"
                        persistent-hint
                        single-line
                        hint="Enter the phone"
                      >
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items="countries.map(x => {return {text: x.countryname, value: x._id};})"
                        v-bind:value="initvalue.countryid"
                        v-on:change="onChangeValue($event, 'countryid')"
                        v-bind:error="errorindex == 8"
                        outlined
                        dense
                        placeholder="Country"
                        persistent-hint
                        single-line hint="Please choose the country">
                      </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        class="mb-4"
                        :items="['USD', 'SGD', 'KHR', 'THB']"
                        v-model="primaryCurrency"
                        v-bind:value="initvalue.primaryCurrency"
                        v-on:change="onChangeValue($event, 'primaryCurrency'); checkCurrency()"
                        v-bind:error="errorindex == 5"
                        outlined
                        dense
                        placeholder="Primary Currency"
                        persistent-hint
                        single-line
                        hint="Please choose the primary currency"
                      >
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="['USD', 'SGD', 'KHR', 'THB']"
                        v-model="secondaryCurrency"
                        v-bind:value="initvalue.secondaryCurrency"
                        v-on:change="onChangeValue($event, 'secondaryCurrency'); checkCurrency()"
                        outlined
                        dense
                        placeholder="Secondary Currency"
                        persistent-hint
                        single-line
                        hint="Please choose the secondary currency"
                      >
                      </v-select>
                      <v-text-field
                        class="mb-4"
                        v-model="currencyRate"
                        v-bind:value="initvalue.currencyRate"
                        v-on:change="onChangeValue($event, 'currencyRate')"
                        outlined
                        v-bind:error="errorindex == 11"
                        dense
                        placeholder="Currency Rate"
                        persistent-hint
                        single-line
                        hint="Enter the currency rate"
                      >
                      </v-text-field>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        class="mb-4"
                        :items="invoicepayterms"
                        v-bind:value="initvalue.invoicepayterms"
                        v-on:change="onChangeValue($event, 'invoicepayterms')"
                        v-bind:error="errorindex == 5"
                        outlined
                        dense
                        placeholder="Pay Terms"
                        persistent-hint
                        single-line
                        hint="Please choose the pay terms"
                      >
                      </v-select>
                      <v-textarea
                          v-bind:value="initvalue.invoicenote"
                          v-on:change="onChangeValue($event, 'invoicenote')"
                          outlined
                          rows=3
                          label="Note"
                          hint="please enter the note"
                        ></v-textarea>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/invoice/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Cancel
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        :loading="isReceiving"
                        class="button-shadow"
                        color="primary"
                        @click="updateInvoice()"
                      >
                        Save
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-items'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center" v-if="initvalue.invoicetype=='Sales Invoice'">
                        <v-col lg="12" md="12" sm="12"><p class="text-h5">Items</p></v-col>
                        <v-col md="2">
                          <v-select
                            class="mb-4"
                            :items="
                              brands.filter(brand=>brand.brandtype=='Brand').map((x) => {
                                return { text: x.brandname, value: x._id };
                              })
                            "
                            v-model="new_transaction.brandid"
                            v-bind:error="errorindex == 2"
                            v-on:change="populateItems"
                            outlined
                            dense
                            placeholder="Brand"
                            persistent-hint
                            single-line
                            hint="Brand"
                          >
                          </v-select>
                        </v-col>
                        <v-col md="4">
                          <v-select
                            class="mb-4"
                            :items="new_transaction.branditems"
                            v-model="new_transaction.itemid"
                            v-bind:error="errorindex == 0"
                            v-on:change="populatePriceField"
                            outlined
                            dense
                            placeholder="Item"
                            persistent-hint
                            single-line
                            hint="Item"
                          >
                          </v-select>
                        </v-col>
                        <v-col md="1">
                          <v-text-field
                            v-model="new_transaction.itemquantity"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Qty"
                            persistent-hint
                            type="number"
                            v-on:input="calculateAmount"
                            oninput="if(this.value < 1) this.value = 1;"
                            single-line
                            hint="Quantity"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col md="1">
                          <v-text-field
                            readonly
                            v-model="new_transaction.itemprice"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Prc"
                            persistent-hint
                            single-line
                            hint="Price"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col md="2">
                          <v-text-field
                            readonly
                            v-model="new_transaction.itemamount"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Amt"
                            persistent-hint
                            single-line
                            hint="Amount"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col md="1">
                          <v-btn
                            class="button-shadow"
                            color="success"
                            @click="insertTransaction()"
                          >
                            Add
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row justify="center" v-if="initvalue.invoicetype=='Service Invoice'">
                        <v-col lg="12" md="12" sm="12"><p class="text-h5">Items</p></v-col>
                        <v-col cols="12" sm="12" md="3" lg="3">
                          <v-select
                            class="mb-4"
                            :items="accounts.filter(account=>account.accountclass=='Revenue' && account.accountsubclass=='Service Income').map(x => {
                              return {text: x.accountname, value: x._id};
                            })"
                            v-model="new_transaction.accountid"
                            v-bind:error="errorindex == 11"
                            outlined
                            dense
                            placeholder="Account"
                            persistent-hint
                            single-line hint="Account">
                          </v-select>
                        </v-col>
                        <v-col cols="12" sm="12" md="3" lg="3">
                          <v-text-field
                            v-model="new_transaction.itemdesc"
                            v-bind:error="errorindex == 12"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Desc"
                            persistent-hint
                            single-line hint="Description">
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="2" lg="2">
                          <v-text-field
                            type="number"
                            v-model="new_transaction.itemamount"
                            v-bind:error="errorindex == 13"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Amt"
                            persistent-hint
                            single-line hint="Amount">
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="1" lg="1">
                          <v-btn
                            class="button-shadow"
                            color="success"
                            @click="insertInvoiceTransaction()">
                            Add
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-data-table
                        v-if="initvalue.invoicetype=='Sales Invoice'"
                        :headers="itemHeaders1"
                        :items="transactions"
                        :items-per-page="100"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteTransaction" width="500">
                            <v-card>
                              <v-card-title> Delete this Item? </v-card-title>
                              <v-card-text>
                                {{ delete_transaction.itemname }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteTransaction = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteTransaction(delete_transaction)"
                                  >Delete</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.itemimage="{ item }">
                          <v-img
                            v-bind:lazy-src="item.itemimage"
                            min-width="50"
                            max-width="100"
                            v-bind:src="item.itemimage"
                          ></v-img>
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="loadEditTransaction(item)"
                          >
                            <v-icon>mdi-pencil-outline</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteTransactionDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                        <template slot="body.append">
                          <tr>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th>Subtotal</th>
                            <th>{{ invoice_subtotal }}</th>
                            <th></th>
                          </tr>
                          <tr>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th>Total</th>
                            <th>{{ invoice_total }}</th>
                            <th></th>
                          </tr>
                        </template>
                      </v-data-table>
                      <v-data-table
                        v-if="initvalue.invoicetype=='Service Invoice'"
                        :headers="itemHeaders2"
                        :items="transactions"
                        :items-per-page="100"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteTransaction" width="500">
                            <v-card>
                              <v-card-title> Delete this Item? </v-card-title>
                              <v-card-text>
                                {{ delete_transaction.itemname }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteTransaction = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteTransaction(delete_transaction)"
                                  >Delete</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.itemimage="{ item }">
                          <v-img
                            v-bind:lazy-src="item.itemimage"
                            min-width="50"
                            max-width="100"
                            v-bind:src="item.itemimage"
                          ></v-img>
                        </template>
                        <template v-slot:item.accountid="{ item }">
                          <p class="two-line">{{ accounts.length>0 ? accounts.find(account=>account._id == item.accountid)['accountnum'] : '' }}: {{ accounts.length>0 ? accounts.find(account=>account._id == item.accountid)['accountname'] : '' }}</p>
                        </template>
                        <template v-slot:item.itemamount="{ item }">
                          <p class="two-line">{{ item.itemamount.toFixed(2) }}</p>
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="loadEditTransaction(item)"
                          >
                            <v-icon>mdi-pencil-outline</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteTransactionDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                        <template slot="body.append">
                          <tr>
                            <th></th>
                            <th>Subtotal</th>
                            <th>{{ invoice_subtotal }}</th>
                            <th></th>
                          </tr>
                          <tr>
                            <th></th>
                            <th>Total</th>
                            <th>{{ invoice_total }}</th>
                            <th></th>
                          </tr>
                        </template>
                      </v-data-table>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/invoice/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-files'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                        <v-col md="11">
                          <p class="text-h5">Files</p>
                        </v-col>
                        <v-col md="1">
                          <v-btn
                            class="button-shadow"
                            color="secondary"
                            @click="isUploadFile = true"
                          >
                            Add
                          </v-btn>
                        </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        :headers="fileHeaders"
                        :items="files"
                        :items-per-page="100"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteFile" width="500">
                            <v-card>
                              <v-card-title> Delete this File? </v-card-title>
                              <v-card-text>
                                {{ deletefile.filename }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteFile = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteFile(deletefile)"
                                  >Delete</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.filetype="{ item }">
                            <a v-if="item.filetype=='pdf'" :href="item.fileurl" style="text-decoration: none !important;">
                              <v-icon 
                            size="50"
                            color="primary"
                            >
                              mdi-file-pdf-box
                            </v-icon></a>    
                        </template>
                        <template v-slot:item.filesize="{ item }">
                            {{ (item.filesize/1000).toFixed(0) + " KB"  }}    
                        </template>
                        <template v-slot:item.createdAt="{ item }">
                          {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}
                        </template>
                        <template v-slot:item.actions="{ item }">

                          <v-btn
                            icon
                            color="primary"
                            @click="deleteFileDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>

                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/invoice/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <div class="text-center">
      <v-dialog
        v-model="isUploadFile"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Upload File</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                <v-file-input label="File input" v-model="upload.file" v-on:change="onChangeFile" accept=".pdf" />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="upload.filename"
                    label="File Name"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isUploadFile = false; upload.file=null; upload.filename=''"
            >
              Close
            </v-btn>
            <v-btn
              :disabled="upload.file==null"
              color="blue darken-1"
              text
              @click="uploadFile"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-bottom-sheet v-model="isEditTransaction" max-height="200px">
        <v-card>
          <v-row justify="center">
            <v-btn class="mt-6" text color="error" @click="isEditTransaction = !isEditTransaction">
              close
            </v-btn>
          </v-row>


          <v-row justify="center" v-if="initvalue.billtype=='Sales Invoice'">
            <v-col cols="12" md="2">
              <v-select
                class="mb-4"
                :items="
                  brands.filter(brand=>brand.brandtype=='Brand').map((x) => {
                    return { text: x.brandname, value: x._id };
                  })
                "
                v-model="edit_transaction.brandid"
                v-bind:error="errorindex == 2"
                v-on:change="populateItems"
                outlined
                dense
                placeholder="Brand"
                persistent-hint
                single-line
                hint="Brand"
              >
              </v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                class="mb-4"
                :items="edit_transaction.branditems"
                v-model="edit_transaction.itemid"
                v-bind:error="errorindex == 0"
                v-on:change="populatePriceField"
                outlined
                dense
                placeholder="Item"
                persistent-hint
                single-line
                hint="Item"
              >
              </v-select>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                v-model="edit_transaction.itemquantity"
                oninput="if(this.value < 0) this.value = 1;"
                class="mb-4"
                outlined
                dense
                placeholder="Qty"
                persistent-hint
                type="number"
                v-on:input="calculateAmount"
                single-line
                hint="Qty"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="1">
              <v-text-field
                readonly
                v-model="edit_transaction.itemprice"
                class="mb-4"
                outlined
                dense
                placeholder="Prc"
                persistent-hint
                single-line
                hint="Price"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                readonly
                v-model="itemamount"
                class="mb-4"
                outlined
                dense
                placeholder="Amt"
                persistent-hint
                single-line
                hint="Amount"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row justify="center" v-if="initvalue.invoicetype=='Service Invoice'">
            <v-col cols="12" sm="12" md="3" lg="3">
              <v-select
                class="mb-4"
                :items="accounts.filter(account=>account.accountclass=='Revenue' && account.accountsubclass=='Service Income').map(x => {
                  return {text: x.accountname, value: x._id};
                })"
                v-model="edit_transaction.accountid"
                v-bind:error="errorindex == 11"
                outlined
                dense
                placeholder="Account"
                persistent-hint
                single-line hint="Account">
              </v-select>
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="3">
              <v-text-field
                v-model="edit_transaction.itemdesc"
                v-bind:error="errorindex == 12"
                class="mb-4"
                outlined
                dense
                placeholder="Desc"
                persistent-hint
                single-line hint="Description">
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="2" lg="2">
              <v-text-field
                type="number"
                v-model="edit_transaction.itemamount"
                v-bind:error="errorindex == 13"
                class="mb-4"
                outlined
                dense
                placeholder="Amt"
                persistent-hint
                single-line hint="Amount">
              </v-text-field>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col>
              <div class="text-center" style="padding-bottom: 20px;">
                <v-btn
                  class="button-shadow"
                  color="warning"
                  @click="updateTransaction()"
                >
                  Edit
                </v-btn>
              </div>

            </v-col>
          </v-row>
        </v-card>
      </v-bottom-sheet>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { formatStdDate } from '@/mixins/date';
import router from "@/Routes";

export default {
  data() {
    return {
      itemHeaders1: [
        { text: 'Image', value: 'itemimage' },
        { text: 'Name', value: 'itemname' },
        { text: 'Foc', value: 'itemfoc' },
        { text: 'Qty', value: 'itemquantity', width: '10%'},
        { text: 'Prc', value: 'itemprice', width: '10%'},
        { text: 'Amount', value: 'itemamount', width: '10%'},
        { text: "Actions", value: "actions", sortable: false },
      ],
      itemHeaders2: [
        { text: 'Account', value: 'accountid' },
        { text: 'Description', value: 'itemdesc', width: '30%'},
        { text: 'Amount', value: 'itemamount', width: '10%'},
        { text: "Actions", value: "actions", sortable: false },
      ],
      fileHeaders: [
        { text: "Type", value: "filetype" },
        { text: "Name", value: "filename" },
        { text: "Size", value: "filesize" },
        { text: "Created", value: "createdAt" },
        { text: "Actions", value: "actions", sortable: false },
      ],

      
      delete_transaction: {},
      deletefile: {},
      trade: {},
      searchcustomer: {},
      initvalue: {},
      new_transaction: {branditems:[]},
      edit_transaction: {branditems:[]},
      change_invoice: {},
      
      upload: {filename: null,file: null},
      files: [],
      branditems: [],
      invoicetype: ["Invoice", "Service Invoice"],
      invoicepayterms: ['Cash', 'Credit 15 Days', 'Credit 30 Days', 'Due on Receipt'],
      incoterms: ["FOB", "CIF", "Ex-works"],
      transactions: [],

      route: 0,
      invoice_subtotal: 0,
      invoice_total: 0,
      currencyRate: null,
      primaryCurrency: null,
      secondaryCurrency: null,

      isEditTransaction: false,
      isUploadFile: false,
      brandid: undefined,
      price: undefined,

      itemimage: undefined,
      itemid: undefined,
      itemname: undefined,
      itemquantity: 1,
      itemfoc: undefined,
      itemprice: undefined,
      itemamount: undefined,
      itemcategoryid: undefined,
      itemsubcategoryid: undefined,
      
      invoicedate: null,
      etddate: null,
      etadate: null,
      menu_invoicedate: false,
      menu_etddate: false,
      menu_etadate: false,

      isDeleteFile: false,
      isDeleteTransaction: false,    
      errorindex: undefined,
    };
  },
  computed: {
    ...mapState("Account", ["accounts"]),
    ...mapState("Brand", ["brands"]),
    ...mapState("Customer", ["customers"]),
    ...mapState("Item", ["items"]),
    ...mapState("Location", ["locations"]),
    ...mapState("Price", ["prices"]),
    ...mapState("PriceList", ["pricelists"]),
    ...mapState("Country", ["countries"]),
    ...mapState("Township", ["townships"]),
    ...mapState("Invoice", ["isReceiving"]),
    ...mapState("User", ["users"]),
  },
  methods: {
    ...mapActions("Account", ["getAccountsRequest"]),
    ...mapActions("Brand", ["getBrandsRequest"]),
    ...mapActions("Customer", ["getCustomersRequest"]),
    ...mapActions("File", ["insertRouteFile", "deleteFileRequest", "getInvoiceFiles"]),
    ...mapActions("Item", ["getItemsRequest"]),
    ...mapActions("Location", ["getLocationsRequest"]),
    ...mapActions("Price", ["getPricesRequest"]),
    ...mapActions("PriceList", ["getPriceListsRequest"]),
    ...mapActions("Country", ["getCountriesRequest"]),
    ...mapActions("Invoice", ["deleteInvoiceTransactionRequest", "getInvoicesRequest", "insertInvoiceTransactionRequest", "updateInvoiceRequest", "updateInvoiceTransaction", "updateInvoiceTrade",]),
    ...mapActions("Township", ["getTownshipsRequest"]),
    ...mapActions("User", ["getUsersRequest"]),
    checkCurrency(){
      if(this.primaryCurrency==this.secondaryCurrency) {
        this.currencyRate=1;
        this.change_invoice.currencyRate=1;
      }
    },
    checkError() {
      if (!this.accessname) {
        this.errorindex = 0;
        return false;
      }
      if (!this.accesspath) {
        this.errorindex = 1;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    checkError3(){
      if(!this.new_transaction.accountid){
        this.haserrors = true;
        this.errorindex = 11;
        return false;
      }
      if(!this.new_transaction.itemdesc){
        this.haserrors = true;
        this.errorindex = 12;
        return false;
      }
      if(!this.new_transaction.itemamount){
        this.haserrors = true;
        this.errorindex = 13;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    calculateAmount() {
      if(this.route==0)this.new_transaction.itemamount = this.new_transaction.itemquantity * this.new_transaction.itemprice;
      else if(this.route==1)this.edit_transaction.itemamount = this.edit_transaction.itemquantity * this.edit_transaction.itemprice;
      this.itemamount = this.edit_transaction.itemamount;  
    },
    calculateTotal() {
      if(!this.transactions) return;
      this.invoice_subtotal = this.transactions.reduce((a, b) => a + b.itemamount, 0);
      this.invoice_total = this.invoice_subtotal;
    },
    clearTransaction() {
      this.edit_transaction = {branditems:[]};
      this.new_transaction = {branditems:[]};
    },
    deleteTransactionDialog(item) {
      this.isDeleteTransaction = true;
      this.delete_transaction = {_id: item._id, itemname: item.itemname, itemquantity: item.itemquantity};
    },
    deleteFileDialog(item) {
      this.isDeleteFile = true;
      this.deletefile = {_id: item._id,filename: item.filename,};
    },
    async deleteFile(payload) {
      this.isDeleteFile = false;
      let response = await this.deleteFileRequest(payload);
      let index = this.files.findIndex((trans) => trans._id == response._id);
      this.files.splice(index, 1);
    },
    async deleteTransaction(payload) {
      this.isDeleteTransaction = false;
      let response = await this.deleteInvoiceTransactionRequest(payload);
      let index = this.transactions.findIndex((trans) => trans._id == response._id);
      this.transactions.splice(index, 1);
      this.calculateTotal();
      this.getInvoicesRequest();
    },
    async insertInvoiceTransaction() {
      if(!this.checkError3()) return;
      let payload = {
        invoiceid: this.initvalue._id,
        accountid: this.new_transaction.accountid,
        itemdesc: this.new_transaction.itemdesc,
        itemamount: this.new_transaction.itemamount,
      };
      console.log(payload)
      let response = await this.insertInvoiceTransactionRequest(payload);
      this.transactions.push(response);
      this.calculateTotal();
      this.clearTransaction();
    },
    async insertTransaction() {
      let payload = {
        invoiceid: this.initvalue._id,
        brandid: this.new_transaction.brandid,
        itemid: this.new_transaction.itemid,
        itemimage: this.new_transaction.itemimage,
        itemname: this.new_transaction.itemname,
        itemquantity: this.new_transaction.itemquantity,
        itemfoc: this.new_transaction.itemfoc,
        itemprice: this.new_transaction.itemprice,
        itemamount: this.new_transaction.itemamount,
        itemcategoryid: this.new_transaction.itemcategoryid,
        itemsubcategoryid: this.new_transaction.itemsubcategoryid,
      };
      let response = await this.insertInvoiceTransactionRequest(payload);
      this.transactions.push(response);
      this.calculateTotal();
      this.clearTransaction();
    },
    loadEditTransaction(item) {
      this.route = 1;
      this.isEditTransaction = !this.isEditTransaction;
      this.edit_transaction._id = item._id;
      this.edit_transaction.accountid = item.accountid;
      this.edit_transaction.itemdesc = item.itemdesc;
      this.edit_transaction.itemamount = item.itemamount;
    },
    onChangeFile(file) {
      if (!file) this.upload.file = null;
      else this.upload.file = file;
    },
    onChangeValue(value, field) {
      this.change_invoice[field] = value;
    },
    onChangeTrade(value, field) {
      this.trade[field] = value;
    },
    populateCustomerFields(customerid) {
      var customer = this.customers.find((customer) => customer._id == customerid);
      this.invoice.invoicename = customer.customername;
      this.invoice.invoiceaddress = customer.customeraddress;
      this.invoice.invoicephone = customer.customerphone;
      this.invoice.invoicemobile = customer.customermobile;
      this.invoice.townshipid = customer.townshipid;
      this.invoice.pricelistid = customer.pricelistid;
    },
    populateItems(brandid) {
      console.log(this.route, brandid)
      let branditems = this.items.filter((item) => item.brandid == brandid);
      console.log(branditems)
      if(this.route==0) this.new_transaction.branditems = branditems.map((x) => {return { text: x.itemname, value: x._id }});
      else if(this.route==1) this.edit_transaction.branditems = branditems.map((x) => {return { text: x.itemname, value: x._id }});
    },
    populatePriceField(itemid) {
      let price = this.prices.find((price) =>price.itemid == itemid && price.pricelistid == this.initvalue.pricelistid);
      let item = this.items.find((item) => item._id == itemid);
      if(this.route==0){
        this.new_transaction = Object.assign(this.new_transaction, item);
        this.new_transaction.itemprice = price.listprice;
      }
      else if(this.route==1){
        this.edit_transaction = Object.assign({},item);
        this.edit_transaction.itemprice = price.listprice;
      }
      this.calculateAmount();
    },

    searchCustomerDialog(){
      this.searchcustomer = {};
      this.isSearchCustomer = true;
    },
    


    async updateInvoice() {
      this.change_invoice._id = this.initvalue._id;
      await this.updateInvoiceRequest(this.change_invoice);
      router.push("/invoice/list");
    },
    async updateTransaction() {
      this.isEditTransaction = false;
      console.log(this.edit_transaction)
      let response = await this.updateInvoiceTransaction(this.edit_transaction);
      let index = this.transactions.findIndex((x) => x._id == response._id);
      this.transactions.splice(index, 1, response);
      this.calculateTotal();
      this.clearTransaction();
      this.getInvoicesRequest();
    },
    async uploadFile(){
      this.isUploadFile = false;
      this.upload.id = this.initvalue._id;
      this.upload.route = 'invoice';
      let file = await this.insertRouteFile(this.upload);
      this.files.push(file);
      this.upload = {filename: null,file: null};
    },
  },

  async created() {
    this.initvalue = this.$route.params;

    if (!this.initvalue._id) this.$router.push({ name: "InvoiceList" });
    if (this.accounts.length==0) await this.getAccountsRequest();
    if (this.brands.length==0) await this.getBrandsRequest();
    if (this.customers.length==0) await this.getCustomersRequest();
    if (this.items.length==0) await this.getItemsRequest();
    if (this.locations.length==0) await this.getLocationsRequest();
    if (this.prices.length==0) await this.getPricesRequest();
    if (this.pricelists.length==0) await this.getPriceListsRequest();
    if (this.countries.length==0) await this.getCountriesRequest();
    if (this.townships.length==0) await this.getTownshipsRequest();
    if (this.users.length==0) await this.getUsersRequest();

    this.files = this.initvalue.files;
    this.transactions = this.initvalue.transactions;
    this.calculateTotal();

    this.invoicedate = formatStdDate(this.initvalue.invoicedate);
    this.currencyRate = this.initvalue.currencyRate;
    this.primaryCurrency = this.initvalue.primaryCurrency;
    this.secondaryCurrency = this.initvalue.secondaryCurrency;
  },
};
</script>

<style src="./Edit.scss" lang="scss"></style>
